

function IsOnline({ isOnline }) {
    return (
        <div className="flex flex-row-reverse items-center">
            {
                isOnline ?
                    <div className="flex flex-row-reverse items-center bg-green-50 rounded text-slate-700 text-sm px-2 pt-1">
                        <span className="p-1 ml-1 rounded-full bg-green-400"></span>
                        <span>آنلاین</span>
                    </div>
                    :
                    <div className="flex flex-row-reverse items-center bg-slate-200 rounded text-slate-700 text-sm px-2 pt-1">
                        <span className="p-1 ml-1 rounded-full bg-slate-400"></span>
                        <span>آفلاین</span>
                    </div >
            }
        </div>
    )
}
export default IsOnline;